// extracted by mini-css-extract-plugin
export default {"wrapper":"e0-z","play":"f0-z"};